export const estimatorConstants = {
  SET_BID_LANDSCAPE_PAYLOAD: 'SET_BID_LANDSCAPE_PAYLOAD',
  SET_TARGATABLE_AUDIENCE_PAYLOAD: 'SET_TARGATABLE_AUDIENCE_PAYLOAD',
  SET_REACH_IMPRESSION_PAYLOAD: 'SET_REACH_IMPRESSION_PAYLOAD',
  SET_ESTIMATOR_KEYS: 'SET_ESTIMATOR_KEYS',
  FETCH_ESTIMATOR_KEYS: 'FETCH_ESTIMATOR_KEYS',
  SET_ESTIMATOR_META_DATA: 'SET_ESTIMATOR_META_DATA',
  SET_ESTIMATOR_STALE_CONDITION: 'SET_ESTIMATOR_STALE_CONDITION',
};
